import anime from 'animejs';

export default function staggerAnim(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const items = [...elToTween.querySelectorAll('[data-item]')];

  const tween = anime({
    targets: items,
    opacity: 1,
    translateY: 0,
    duration: 1600,
    delay: anime.stagger(80),
  });

  return tween;
}
